import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useStartCsaCheckout } from "../../hooks/useStartCsaCheckout";
import LoadingSpinner from "../../../LoadingSpinner";

const PayCsaCheckoutPage = () => {
  const { startCsaCheckout, isStartingCheckout, checkoutError } =
    useStartCsaCheckout();

  useEffect(() => {
    void startCsaCheckout();
    // Run once on mount to redirect to a fresh Stripe Checkout session.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-container">
      <h1>CSA payment</h1>
      {checkoutError ? (
        <div className="page-content">
          <div className="pay-csa-checkout-page info-card">
            <p>{checkoutError}</p>
            <button
              type="button"
              className="btn"
              onClick={() => void startCsaCheckout()}
            >
              Try again
            </button>
            <p>
              <Link to="/dashboard/client">Back to My Subscription</Link>
            </p>
          </div>
        </div>
      ) : (
        <div className="pay-csa-checkout-page info-card">
          {isStartingCheckout ? (
            <p>Redirecting to secure payment…</p>
          ) : (
            <LoadingSpinner />
          )}
        </div>
      )}
    </div>
  );
};

export default PayCsaCheckoutPage;
